<div class="article-page-wrapper">
  <div class="article-container content-wrapper">
    <div class="article-header-wrapper">
      <h1 class="title">Student Life</h1>
      <div class="separator"></div>

      <div class="header-layout">
        <h2 class="article-title">{{ article.title }}</h2>

        <div class="article-meta-data">
          <p>By {{ article.author }}</p>
          <p>Created {{ article.date_published | dateFormat }}.</p>
        </div>
      </div>
    </div>

    <div class="article-body-wrapper">
      <div class="article-body">
        <app-render-markdown
          [content]="article.article_body!"
        ></app-render-markdown>
      </div>
      <div class="article-info">
        <p>
          By {{ article.author }}, Created on
          {{ article.date_published | dateFormat }}.
        </p>
      </div>
    </div>
    <!-- sanitizeHtml pipe bypasses DOM sanitation checks to display all the custom text -->
    <div class="article-footer-container">
      <div *ngIf="similarArticles.length" class="similar-articles-container">
        <h3>More articles like these:</h3>
        <a
          *ngFor="let a of similarArticles"
          class="similar-article-link"
          href="{{ '/app/student-life/' + a.uid }}"
          >{{ a.title }}
        </a>
      </div>
    </div>
  </div>
</div>
